type t_IntakeProgressDataConfig = Record<string, any>;
type t_IntakeProgressFunction = (index: number, ...args: any[]) => any;

interface IIntakeProgressConfig {
  onAdvance: t_IntakeProgressFunction;
  onGoTo: t_IntakeProgressFunction;
  tabData?: t_IntakeProgressDataConfig;
}
export class IntakeService {
  private _onComplete: (...args: any[]) => any;
  private _advance: (...args: any[]) => any;
  private _goTo: (...args: any[]) => any;
  private _activeTab: number;
  private _tabDataConfig?: t_IntakeProgressDataConfig;

  constructor() {
    this.initialize();
  }

  setOnAdvance(fn: t_IntakeProgressFunction): void {
    if (_.isFunction(fn)) {
      this._advance = fn;
    } else {
      this._advance = angular.noop;
    }
  }
  setOnGoTo(fn: t_IntakeProgressFunction): void {
    if (_.isFunction(fn)) {
      this._goTo = fn;
    } else {
      this._goTo = angular.noop;
    }
  }
  setOnCompletion(fn: t_IntakeProgressFunction): void {
    if (_.isFunction(fn)) {
      this._onComplete = fn;
    } else {
      this._onComplete = angular.noop;
    }
  }

  onAdvance(index: number, ...args: any[]): t_IntakeProgressFunction {
    const thisTabData: any = _.result(this._tabDataConfig, index);
    args.push(thisTabData);
    return this._advance(index, args);
  }
  onGoTo(index: number, ...args: any[]): t_IntakeProgressFunction {
    const thisTabData: any = _.result(this._tabDataConfig, index);
    args.push(thisTabData);
    return this._goTo(index, args);
  }
  onCompletion(): void {
    this._onComplete();
  }

  initialize(): void {
    this._advance = angular.noop;
    this._goTo = angular.noop;
  }

  configure(configObj: IIntakeProgressConfig): void {
    this.setOnAdvance(configObj.onAdvance);
    this.setOnGoTo(configObj.onGoTo);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/services/intake_question_service.ts